import axios from "axios";
import { handleActions } from "redux-actions";
import Config from "config";
import { getHeaders } from "helpers/headers";
import { AnyAction } from "interfaces/action";
import { Dispatch } from "interfaces/dispatch";
import { ThunkActionCreator } from "interfaces/thunk";

/* -----------------------------------
   ACTION TYPES
------------------------------------- */
export const FETCH_CHAIN_USER_ROLE_REQUEST = "FETCH_CHAIN_USER_ROLE_REQUEST";
export const FETCH_CHAIN_USER_ROLE_SUCCESS = "FETCH_CHAIN_USER_ROLE_SUCCESS";
export const FETCH_CHAIN_USER_ROLE_FAILED = "FETCH_CHAIN_USER_ROLE_FAILED";

/* -----------------------------------
   INTERFACES
------------------------------------- */
export interface ChainRole {
  id: number;
  role: string;
}

export interface ChainsUserPermissionState {
  chainRoleLoading?: boolean;
  chainRoleError?: boolean;
  chainUserRole?: ChainRole[];
}


/* -----------------------------------
   THUNK ACTION (FETCH CHAIN ROLES)
------------------------------------- */
export const fetchChainRole: ThunkActionCreator<Promise<void>> =
  (selectedChainId) => async (dispatch: Dispatch) => {
    dispatch({ type: FETCH_CHAIN_USER_ROLE_REQUEST });
    try {
      const response = await axios.get(
        `${Config.API_SERVICE_URL}/api/logged-user-chains/permissions/${selectedChainId}`,
        {
          headers: getHeaders(),
        }
      );

      dispatch({
        type: FETCH_CHAIN_USER_ROLE_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.error("Error fetching chain role:", error);
      dispatch({ type: FETCH_CHAIN_USER_ROLE_FAILED });
    }
  };

/* -----------------------------------
   INITIAL STATE
------------------------------------- */
const initialState: ChainsUserPermissionState = {
  chainRoleLoading: false,
  chainRoleError: false,
  chainUserRole: undefined,
};

/* -----------------------------------
   REDUCER
------------------------------------- */
const actions = {
  [FETCH_CHAIN_USER_ROLE_REQUEST]: (
    state: ChainsUserPermissionState
  ) => ({
    ...state,
    chainRoleLoading: true,
    chainRoleError: false,
    chainUserRole: undefined,
  }),

  [FETCH_CHAIN_USER_ROLE_SUCCESS]: (
    state: ChainsUserPermissionState,
    action: AnyAction
  ) => ({
    ...state,
    chainRoleLoading: false,
    chainUserRole: action.payload,
  }),

  [FETCH_CHAIN_USER_ROLE_FAILED]: (
    state: ChainsUserPermissionState
  ) => ({
    ...state,
    chainRoleLoading: false,
    chainRoleError: true,
    chainUserRole: undefined,
  }),
};

/* -----------------------------------
   FINAL REDUCER EXPORT
------------------------------------- */
export default handleActions<ChainsUserPermissionState, AnyAction>(
  actions,
  initialState
);
